import { formatCsv } from './format-csv.js';
import { downloadCSV } from '../../../core/utils/download.js';
import { CSS_DOWNLOAD_FILENAME } from '../../core/constants.js';
import { DonutChartData, PieChartData } from '../types/pie-chart.config.js';

export const buildAndDownloadCsv = (
  chartData: PieChartData | DonutChartData,
) => {
  const csvString = formatCsv(chartData);
  downloadCSV(csvString, CSS_DOWNLOAD_FILENAME);
};
